<template>
  <div id="stand-saloons-dialog" class="custom-modal">
    <div class="modal-body">
      <HolaconLottie v-if="loading == 'created'" class="w-100" key="create-loading" />
      <el-row :gutter="10" v-else key="content-loading">
        <el-col :span="24" v-if="$store.state.stands.saloons.length > 0">
          <div class="saloons-header custom-grid-table-header">
            <div>#</div>
            <div>{{ $t("contentManagement.stands.standSaloon.title") }}</div>
            <div>{{ $t("contentManagement.stands.standSaloon.color") }}</div>
            <div>{{ $t("contentManagement.stands.standSaloon.view") }}</div>
            <div></div>
          </div>
          <draggable :list="$store.state.stands.saloons" tag="div" handle=".el-icon-s-grid" class="list-group-o standsaloon-add-container" v-bind="dragOptions" @start="dragList = true" @end="changeSaloonSort">
            <div class="item" v-for="(item, index) in $store.state.stands.saloons" :key="index" :class="{ passive: !item.isActive }">
              <div class="table-icon">
                <i class="el-icon-s-grid burger"></i>
              </div>
              <div class="img-title">
                <div class="img-title-alt">
                  {{ item.title }}
                </div>
              </div>
              <div>
                <div class="square-color-pick" :style="{ 'background-color': item.color }"></div>
              </div>
              <div><el-switch v-model="item.isActive" @change="updateActive(item)"></el-switch></div>
              <div style="display:flex; gap:0.2rem">
                <el-tooltip class="" effect="dark" :content="$t('event.buttons.edit')" placement="top">
                <el-button
                  type="success"
                  icon="fas fa-pen"
                  size="mini"
                  circle
                  @click="
                    updateForm = item.id;
                    modalVisible = true;
                  "
                ></el-button>
                </el-tooltip>
                <el-tooltip class="" effect="dark" :content="$t('event.buttons.delete')" placement="top">
                  <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                    <el-button slot="reference" round size="mini" :loading="loading == 'deleteItem-' + item.id" circle type="danger" icon="fas fa-trash"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </div>
            </div>
          </draggable>
        </el-col>
        <el-row v-else>
          <HolaconLottieNoData
            class="w-100"
            key="create-loading"
            :source="'holacon-expo-lottie'"
            :title="$t('event.tags.halls')"
            @btnAdd="
              updateForm = null;
              modalVisible = true;
            "
            @btnRefresh="false"
            :buttonAdd="true"
            :buttonRefresh="false"
            :loading="loading"
          />
        </el-row>
      </el-row>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.stands.standSaloon.close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button
          type="primary"
          @click="
            updateForm = null;
            modalVisible = true;
          "
          >{{ $t("contentManagement.stands.standSaloon.addSaloon") }}</el-button
        >
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="updateForm != null ? $t('contentManagement.stands.standSaloon.editSaloon') : $t('contentManagement.stands.standSaloon.addSaloon')" class="large" center append-to-body destroy-on-close>
      <SaloonStandAddUpdate @deleteMe="deleteItem" @closeDialog="modalVisible = false" :id="updateForm" v-if="modalVisible" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import PageCountInfo from "./PageCountInfo";
import SaloonStandAddUpdate from "./SaloonStandAddUpdate";
import $ from "jquery";
export default {
  components: { PageCountInfo, SaloonStandAddUpdate, draggable },
  name: "StandSaloons",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary",
      saloonSort: null,
      loading: false,
      dragList: false
    };
  },
  methods: {
    handleSizeChange(take) {
      this.$store.commit("setSubEventsTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSubEventsPage", page);
    },
    deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteStandSaloon", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getStandSaloons");
        }
        this.loading = false;
      }, 500);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    async updateActive(item) {
      await this.$store.dispatch("standSaloonAddUpdate", item);
    },
    changeSaloonSort() {
      if (this.saloonSort != null) clearTimeout(this.saloonSort);
      this.loading = "loadingList";
      this.saloonSort = setTimeout(async () => {
        var payload = [];
        this.$store.state.stands.saloons.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveStandSaloonOrder", payload);
        await this.$store.dispatch("getStandSaloons");
        this.loading = false;
        this.dragList = false;
      }, 500);
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleSubEvents", { index, value });
    }
  },
  mounted() {
    this.loading = "created";
    if (this.saloonSort != null) clearTimeout(this.saloonSort);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getStandSaloons");
      this.loading = false;
    }, 500);
  },
  created() {},
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.stands.filter.page - 1) * this.$store.state.stands.filter.take;
    },
    take() {
      return this.skip + this.$store.state.stands.items.length;
    }
  },
  watch: {
    "$store.state.stands.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getQuestionLibrary");
      }, 500);
    }
  }
};
</script>
<style lang="less">
.saloons-header {
  grid-template-columns: 34px 1fr 90px 90px 90px;
  gap: 0.5rem;
}
.standsaloon-add-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          font-weight: bold;
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 400;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 34px 1fr 90px 90px 90px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 0.5rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.modal-base-mini {
  min-width: 400px;
}

.square-color-pick {
  width: 50%;
  height: 30px;
  border-radius: 8px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/StandSaloons.vue